import React, {useMemo} from "react";
import moment from "moment";
import {DateRangeFilter} from "components/_defaultComponents/FilterComponents";
import {ShiftsDateFilterWrapper} from "../styles/CustomerShiftsPage.styles";

const getDisabledDate = type => {
    const todayStart = moment().startOf("day");
    const todayEnd = moment().endOf("day");

    if (type === "planned") {
        return current => current && current < todayStart;
    }

    if (type === "completed") {
        return current => current && current > todayEnd;
    }

    return undefined;
};

const CustomerShiftsDateRangeFilter = ({filters, setFilters, setCurrentPage, type}) => {
    const dateRangeValue =
        filters?.startDate && filters?.endDate
            ? [moment(filters.startDate), moment(filters.endDate)]
            : null;

    const disabledDate = useMemo(() => getDisabledDate(type), [type]);

    const handleDateRangeChange = dates => {
        setCurrentPage(1);

        if (!dates || !dates[0] || !dates[1]) {
            setFilters(prev => ({
                ...prev,
                startDate: "",
                endDate: ""
            }));
            return;
        }

        setFilters(prev => ({
            ...prev,
            startDate: dates[0].format("YYYY-MM-DD"),
            endDate: dates[1].format("YYYY-MM-DD")
        }));
    };

    return (
        <ShiftsDateFilterWrapper>
            <DateRangeFilter
                label="Tarih Aralığı"
                value={dateRangeValue}
                onChange={handleDateRangeChange}
                disabledDate={disabledDate}
            />
        </ShiftsDateFilterWrapper>
    );
};

export default CustomerShiftsDateRangeFilter;
